// extracted by mini-css-extract-plugin
export var card = "Card-module--card--ca789";
export var content = "Card-module--content--cd4d9";
export var picture = "Card-module--picture--0eb08";
export var image = "Card-module--image--61eb5";
export var title = "Card-module--title--bd778";
export var date = "Card-module--date--91f71";